// Module
var code = `<div class="grid-edit-picker-container" on-mouseleave="@this.restoreDefaultSelection()">
	{{#each rows: rowIndex}}
        {{#each columns: colIndex}}
            <div class="grid-edit-picker-container-item{{#if rowsSelected > rowIndex && columnsSelected > colIndex}} selected{{/if}}"
                on-click="@this.gridItemMouseClick()"
                on-mouseenter="@this.gridItemMouseEnter(rows[rowIndex], columns[colIndex])" ></div>
        {{/each}}
    {{/each}}
</div>`;
// Exports
export default code;